import { get, patch, post, destroy } from './httpClient'

export const getSouvenirs = (params) => get('/product', params)
export const addSouvenir = (body) => post('/product/create', body)
export const updateSouvenir = (body, id) => patch(`/product/update/${id}`, body)
export const deleteSouvenir = (ids) => destroy('/product/delete', { product_id: ids })
